import React from 'react'
import styled from 'styled-components'

const L = styled.h4`
  font-size: 22px;
  line-height: 32px;
  text-transform: uppercase;
  color: #434343;
  font-family: Montserrat, sans-serif;
  font-weight: 400;
`

const Label = ({children}) => {
  return (
    <L>{children}</L>
  )
}

export default Label;
